import React, { useState } from "react";
import { Modal } from "react-bootstrap";

const useConfirm = () => {
  const [promise, setPromise] = useState(null);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [showButtons, setShowButtons] = useState(true);
  const [extraButtons, setExtraButtons] = useState([]);
  const [cancelLabel, setCancelLabel] = useState("No");
  const [confirmLabel, setConfirmLabel] = useState("Yes");

  const confirm = (
    pTitle,
    pMessage,
    pShowButtons = true,
    pExtraButtons = [],
    pCancelLabel = "No",
    pConfirmLabel = "Yes"
  ) => {
    setTitle(pTitle);
    setMessage(pMessage);
    setShowButtons(pShowButtons);
    setExtraButtons(pExtraButtons);
    setCancelLabel(pCancelLabel);
    setConfirmLabel(pConfirmLabel);
    return new Promise((resolve, reject) => {
      setPromise({ resolve });
    });
  };

  const handleClose = () => {
    promise?.resolve(false);
    setPromise(null);
  };

  const handleConfirm = (e) => {
    e.preventDefault();
    e.stopPropagation();
    promise?.resolve(true);
    setPromise(null);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    e.stopPropagation();
    promise?.resolve(false);
    handleClose();
  };
  // You could replace the Dialog with your library's version
  function ConfirmationDialog() {
    return (
      <Modal
        className="confirm-dialog-modal"
        show={promise !== null}
        onHide={handleClose}
      >
        <Modal.Header
          closeButton
          className="bg-colored-reverse text-white fw-bold"
        >
          <Modal.Title className="fw-bold">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-page">
          <span dangerouslySetInnerHTML={{ __html: message }} />
        </Modal.Body>
        {showButtons && (
          <Modal.Footer className="bg-page">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleCancel}
            >
              {cancelLabel}
            </button>
            <button
              type="button"
              className="btn btn-success"
              onClick={handleConfirm}
            >
              {confirmLabel}
            </button>
            {extraButtons?.map((b) => (
              <button
                type="button"
                className="btn btn-success"
                onClick={async () => {
                  if (await b.onClick()) {
                    handleClose();
                  }
                }}
              >
                {b.text}
              </button>
            ))}
          </Modal.Footer>
        )}
      </Modal>
    );
  }
  return [ConfirmationDialog, confirm];
};

export default useConfirm;
